
jQuery('.close_button').on('click',function(){
  jQuery('#popup').removeClass('popup-active');
});

(function(a){function d(e){0<e.clientY||(b&&clearTimeout(b),0>=a.exitIntent.settings.sensitivity?a.event.trigger("exitintent"):b=setTimeout(function(){b=null;a.event.trigger("exitintent")},a.exitIntent.settings.sensitivity))}function c(){b&&(clearTimeout(b),b=null)}var b;a.exitIntent=function(b,f){a.exitIntent.settings=a.extend(a.exitIntent.settings,f);if("enable"==b)a(window).mouseleave(d),a(window).mouseenter(c);else if("disable"==b)c(),a(window).unbind("mouseleave",d),a(window).unbind("mouseenter",
c);else throw"Invalid parameter to jQuery.exitIntent -- should be 'enable'/'disable'";};a.exitIntent.settings={sensitivity:300}})(jQuery);
	
jQuery.exitIntent('enable');
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
var isShown = false;
jQuery(document).bind('exitintent', function() {
	var popup_shown = getCookie('popup-shown')
	if(!isMobile && !isShown && popup_shown !== 1 && popup_shown !== '1' ){
		isShown = true;
		  jQuery('#popup').addClass('popup-active');
		setCookie('popup-shown',1,60);
	}
});
	
function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/;expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

jQuery(document).ready(function() {
  jQuery("a[href='https://www.flanagan.ca/']").attr('target','_blank');
  // Hide slides 1, 2, 3, and 5
  // $('.slideshow-slide:nth-child(4), .slideshow-slide:nth-child(6)').hide();   
});

// JavaScript to add 'lazyload' class to all img tags
window.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('img');
  images.forEach(function(img) {
    img.classList.add('lazyload');
  });
});